import React from "react";
import Navbar from "../components/brut/Navbar";
import Hero from "../components/brut/Hero";
import Market from "../components/brut/Market";
import Catalog from "../components/brut/Catalog";
import Comparison from "../components/brut/Comparison";
import PriceTable from "../components/brut/PriceTable";
import Calculator from "../components/brut/Calculator";
import SalesAndFaq from "../components/brut/SalesAndFaq";
import ApplyForm from "../components/brut/ApplyForm";
import Footer from "../components/brut/Footer";
import WhatsAppButton from "../components/brut/WhatsAppButton";

const B2BPage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Market />
      <Catalog />
      <Comparison />
      <PriceTable />
      <Calculator />
      <SalesAndFaq />
      <ApplyForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default B2BPage;
